import {
  IBasePagingRes,
  IBaseResponseModel,
} from "../../models/common/models.type";
import api from "../remote/baseApi";
import ApiEndpoints from "../remote/apiEndpoints";
import { envConfig } from "../../config/env.config";
import { EContentResponse, ESeoResponse } from "../../models/seo";
import { EBlogResponse, IBlogGetPage } from "../../models/blog";
import { IUser } from "../../models/user";
import { HistoryTranslate } from "../../page/main/AiToolsPage";
import { IGetPageHistoryTransactionByUser } from "../../models/payment";

const API = ApiEndpoints.USER;

const baseURL = envConfig.API_ENDPOINT;

const getPage = (data: IBlogGetPage): Promise<IBasePagingRes<IUser>> => {
  return api.get(baseURL, API.GetPage.url, {
    params: data,
  });
};

const getPageFileByUserId = (
  data: IBlogGetPage,
): Promise<IBasePagingRes<HistoryTranslate>> => {
  return api.get(baseURL, API.GetPageFileByUserId.url, {
    params: data,
  });
};

const getPageFile = (
  data: IGetPageHistoryTransactionByUser,
): Promise<IBasePagingRes<HistoryTranslate>> => {
  return api.get(baseURL, API.GetPageFile.url, {
    params: data,
  });
};

const UserService = {
  getPage,
  getPageFileByUserId,
  getPageFile,
};

export default UserService;
